import validate from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/opt/atlassian/pipelines/agent/build/ui/middleware/auth.global.ts";
import cart_45global from "/opt/atlassian/pipelines/agent/build/ui/middleware/cart.global.ts";
import checkout_45global from "/opt/atlassian/pipelines/agent/build/ui/middleware/checkout.global.ts";
import cio_45global from "/opt/atlassian/pipelines/agent/build/ui/middleware/cio.global.ts";
import order_45return_45global from "/opt/atlassian/pipelines/agent/build/ui/middleware/order-return.global.ts";
export const globalMiddleware = [
  validate,
  auth_45global,
  cart_45global,
  checkout_45global,
  cio_45global,
  order_45return_45global
]
export const namedMiddleware = {}